export const LIST_SHOPS = [
  {
    id: 'shop1',
    name: 'Курская'
  },
  {
    id: 'shop2',
    name: 'Павелецкая'
  },
  {
    id: 'test',
    name: 'Тестовый'
  }
]